<section class="faq section" id="faq">
  <div class="shell-container reveal" appRevealOnScroll="80ms">
    <div class="faq__header">
      <div class="badge">FAQs</div>
      <h2>Answers that keep pet parents confident and calm.</h2>
      <p class="faq__lede">
        Clear, honest guidance about grooming, comfort, and what to expect before and after your visit.
      </p>
    </div>

    <div class="faq__grid">
      <div class="faq__sections" role="region" aria-label="Frequently asked questions">
        <div class="faq__section" *ngFor="let section of sections">
          <h3 class="faq__section-title">{{ section.title }}</h3>
          <div class="faq__list" role="list">
            <div class="faq__item" *ngFor="let item of section.items">
              <button
                class="faq__question"
                type="button"
                (click)="toggleFaq(item.id)"
                [attr.aria-expanded]="activeFaqId === item.id"
                [attr.aria-controls]="item.id"
              >
                <span class="faq__icon" aria-hidden="true"></span>
                <span>{{ item.question }}</span>
                <span class="faq__chevron" aria-hidden="true" [class.is-open]="activeFaqId === item.id">
                  +
                </span>
              </button>
              <div class="faq__answer" [id]="item.id" *ngIf="activeFaqId === item.id">
                <p>{{ item.answer }}</p>
              </div>
            </div>
          </div>
        </div>

        <p class="faq__footer">
          Every pet is different. If you have specific concerns, our team is always happy to talk before
          your visit.
        </p>
      </div>

      <div class="faq__aside">
        <div class="faq__image-wrap">
          <img
            src="assets/shared/faq/image1.jpg"
            alt="Calm dog after grooming in a soft, clean studio"
            class="faq__image"
            loading="lazy"
          />
        </div>
        <p class="faq__aside-text">Still unsure? We are happy to guide you.</p>
      </div>
    </div>
  </div>
</section>
